import axios from "axios";
import { TokenExpiredError, GenericAPIError } from "../exceptions";
const apiWrapper = async (apiFunction) => {
  try {
    return await apiFunction();
  } catch (err) {
    if (axios.isAxiosError(err)) {
      if (err.response?.status === 401) {
        throw new TokenExpiredError();
      }
    }
    throw new GenericAPIError(err?.message);
  }
};
export {
  apiWrapper
};
